const initialState ={
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case 'REQUEST_DELETE_DOCUMENT_SUCCESS':
      delete newState.documents[action.val];
      newState.refresh+=1;
      break;
    case 'REQUEST_CREATE_DOCUMENT_SUCCESS':
    case 'REQUEST_CLONE_DOCUMENT_SUCCESS':
    case 'REQUEST_GET_DOCUMENT_SUCCESS':
    case 'REQUEST_UPDATE_DOCUMENT_SUCCESS':
      if(newState.documents==undefined){newState.documents={}}
      newState.documents[action.val.id]={...action.val};
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_DOCUMENTS_SUCCESS':
      if(newState.documents==undefined){newState.documents={}}
      for(let x of action.val){
        if(newState.documents[x.id]==undefined){newState.documents[x.id]={}} newState.documents[x.id]={...newState.documents[x.id], ...x};
      }
      newState.documents_index=true;
      newState.refresh+=1;
      break;

    case 'REQUEST_DELETE_CHECKLIST_SUCCESS':
      delete newState.checklists[action.val];
      newState.refresh+=1;
      break;
    case 'REQUEST_CLONE_CHECKLIST_SUCCESS':
    case 'REQUEST_CREATE_CHECKLIST_SUCCESS':
    case 'REQUEST_CLONE_CHECKLIST_SUCCESS':
    case 'REQUEST_GET_CHECKLIST_SUCCESS':
      if(newState.checklists==undefined){newState.checklists={}}
      newState.checklists[action.val.id]={...action.val};
      newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_CHECKLIST_SUCCESS':
      window.location.href='/sales_coach/checklists'; //I DO THIS SO THAT WHEN YOU GOT TO PROSPECT VIEW YOU ACTUALLY SEE UPDATES, AND NOT STALE DATA
      newState.refresh += 1;
      break;
    case 'REQUEST_INDEX_CHECKLISTS_SUCCESS':
      if(newState.checklists==undefined){newState.checklists={}}
      for(let x of action.val){
        if(newState.checklists[x.id]==undefined){newState.checklists[x.id]={}} newState.checklists[x.id]={...newState.checklists[x.id], ...x};
      }
      newState.checklists_index=true;
      newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_QUIZZ_SUCCESS':
      delete newState.quizzes[action.val];
      newState.refresh+=1;
      break;
    case 'REQUEST_CREATE_QUIZZ_SUCCESS':
    case 'REQUEST_CLONE_QUIZZ_SUCCESS':
    case 'REQUEST_GET_QUIZZ_SUCCESS':
    case 'REQUEST_UPDATE_QUIZZ_SUCCESS':
      if(newState.quizzes==undefined){newState.quizzes={}}
      newState.quizzes[action.val.id]={...action.val};
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_QUIZZES_SUCCESS':
      if(newState.quizzes==undefined){newState.quizzes={}}
      for(let x of action.val){
        if(newState.quizzes[x.id]==undefined){newState.quizzes[x.id]={}} newState.quizzes[x.id]={...newState.quizzes[x.id], ...x};
      }
      newState.quizzes_index=true;
      newState.refresh+=1;
      break;
    case 'REQUEST_SALES_COACH_REFRESH':
      console.log('REFRESH SALES COACH');
      newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_DEFAULT_SUCCESS':
      delete newState.defaults[action.val.id];
      break;
    case 'REQUEST_SAVE_DEFAULT_SUCCESS':
      if(newState.defaults==undefined){newState.defaults={}}
      newState.defaults[action.val.id]={...action.val};
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_DEFAULTS_SUCCESS':
      if(newState.defaults==undefined){newState.defaults={}}
      console.log(action.val);
      for(let x of action.val){
        if(newState.defaults[x.id]==undefined){newState.defaults[x.id]={}} newState.defaults[x.id]={...newState.defaults[x.id], ...x};
      }
      newState.defaults_index=true;
      newState.refresh+=1;
      break;
    }
  return newState;
}

export default reducer;
